import { Button, Typography, message } from 'antd';
import clsx from 'clsx';
import { t } from '@/utils/translator';
import api from '@/api/api';
import useAuthStore from '@/store/useAuthStore';

const { Paragraph } = Typography;

const CycleActionCell = ({
  record,
  onExpandRow,
  RequiredDocuments = [],
  OptionalDocuments = [],
  hasAnyFeedback,
  refreshCycleData,
}) => {
  const user = useAuthStore((state) => state.user);
  // 동적으로 생성된 문서 ID들 (새로운 API 구조에 맞게 수정)
  const RequiredDocumentIds = RequiredDocuments.map((doc) => doc.document_type['type_code']);
  const OptionalDocumentIds = OptionalDocuments.map((doc) => doc.document_type['type_code']);
  // const AllDocumentIds = [...RequiredDocumentIds, ...OptionalDocumentIds];

  // 필수 문서만 체크 (선택 문서는 업로드 완료 조건에서 제외)
  let UploadCompleted = false;
  if (RequiredDocumentIds.length) {
    UploadCompleted =
      RequiredDocumentIds.length > 0 &&
      RequiredDocumentIds.every(
        (documentTypeId) =>
          record.attachments[documentTypeId] && record.attachments[documentTypeId].length
      );
  } else if (OptionalDocumentIds.length) {
    UploadCompleted =
      OptionalDocumentIds.length > 0 &&
      OptionalDocumentIds.every(
        (documentTypeId) =>
          record.attachments[documentTypeId] && record.attachments[documentTypeId].length
      );
  }

  // 제출하기 핸들러
  const handleSubmit = async () => {
    try {
      // 사이클 상태를 REVIEWING으로 변경
      await api.post(`/estimates/submit/cycles/${record.estimate_site_cycle_id}`, {
        company_id: user.company_id,
        user_id: user.user_id,
        cycle_id: record.estimate_site_cycle_id,
      });

      message.success(t('제출이 완료되었습니다'));
    } catch (error) {
      console.error('Error submitting cycle:', error);
      message.error(t('제출 중 오류가 발생했습니다'));
    } finally {
      // 사업장 정보 다시 불러오기
      if (refreshCycleData) {
        await refreshCycleData();
      }
    }
  };

  return (
    <>
      {['STARTED', 'UPLOADING'].includes(record.cycle_status) && (
        <Button
          type="primary"
          shape="round"
          disabled={!UploadCompleted}
          className={clsx(!UploadCompleted && 'mb-2')}
          onClick={handleSubmit}
        >
          {t('제출하기')}
        </Button>
      )}

      {['STARTED', 'UPLOADING'].includes(record.cycle_status) && !UploadCompleted && (
        <Paragraph className="fw-normal text-danger mb-0" style={{ fontSize: '13px' }}>
          {t('필수 증빙서류 첨부 후 제출가능')}
        </Paragraph>
      )}

      {['REVIEWING'].includes(record.cycle_status) && (
        <span className="text-gray-5 text-light rounded-pill" style={{ wordBreak: 'keep-all' }}>
          {t('증빙서류 검토중')}
        </span>
      )}

      {['DONE', 'FEEDBACK'].includes(record.cycle_status) && hasAnyFeedback(record) && (
        <Button
          danger
          shape="round"
          className="text-light border-light"
          style={{ backgroundColor: '#087990' }}
          disabled={!hasAnyFeedback}
          onClick={() => {
            onExpandRow((prev) =>
              prev.includes(record.cycle_index)
                ? prev.filter((k) => k !== record.cycle_index)
                : [...prev, record.cycle_index]
            );
          }}
        >
          {t('피드백 보기')}
        </Button>
      )}
    </>
  );
};

export default CycleActionCell;
